module.exports = __webpack_public_path__ + "af360b6e36f133ba9439f969d274f37f.png";